/**
 * Homepage managed sections — used by the CMS to toggle visibility and
 * (for the cinematic late-stage block) reorder.
 *
 * Two groups:
 *   FIXED_SECTIONS    — visibility-only.  Position in the page is fixed.
 *   ORDERED_SECTIONS  — visibility + drag-and-drop reorder inside the
 *                       cinematic late-stage block.
 *
 * Keeping the keys in code (not just in the DB) lets us validate any
 * order array coming from the CMS and gracefully drop unknown keys.
 */

export const MANAGED_SECTIONS = {
  featuredEvents: {
    key: "featuredEvents",
    label: "Featured Events strip",
    description:
      "Premium 'Step into what's next' strip right after the hero. Driven by events flagged Featured in the Events CMS.",
    defaultVisible: true,
    position: "fixed-after-hero",
  },
  midPhilosophy: {
    key: "midPhilosophy",
    label: "Mid-page philosophy banner",
    description:
      "Cinematic full-width quote band between Partners and the social ecosystem.",
    defaultVisible: true,
    position: "ordered",
  },
  socialEcosystem: {
    key: "socialEcosystem",
    label: "Social ecosystem (Follow TOK)",
    description:
      "Featured social card + four follow buttons.",
    defaultVisible: true,
    position: "ordered",
  },
  pyramidPortal: {
    key: "pyramidPortal",
    label: "Pyramid Portal — core philosophy",
    description:
      "Cinematic parallax band with the 'awaken the village' line.",
    defaultVisible: true,
    position: "ordered",
  },
  testimonials: {
    key: "testimonials",
    label: "Testimonials / funder quotes (placeholder)",
    description:
      "Future-ready slot for testimonials + funder quotes. Renders nothing on the live site until you turn it on and add quotes.",
    defaultVisible: false,
    position: "ordered",
  },
};

export const ORDERED_SECTION_KEYS = Object.values(MANAGED_SECTIONS)
  .filter((s) => s.position === "ordered")
  .map((s) => s.key);

export const DEFAULT_ORDERED_SECTIONS = [
  "midPhilosophy",
  "pyramidPortal",
  "socialEcosystem",
  "testimonials",
];

export function resolveOrder(cmsOrder) {
  // Sanitise any incoming order array — drop unknowns, append missing.
  const allowed = new Set(ORDERED_SECTION_KEYS);
  const order = Array.isArray(cmsOrder) ? cmsOrder.filter((k) => allowed.has(k)) : [];
  for (const k of DEFAULT_ORDERED_SECTIONS) {
    if (!order.includes(k)) order.push(k);
  }
  return order;
}

export function isVisible(visibilityMap, key) {
  if (visibilityMap && Object.prototype.hasOwnProperty.call(visibilityMap, key)) {
    return Boolean(visibilityMap[key]);
  }
  return MANAGED_SECTIONS[key]?.defaultVisible ?? true;
}
